import { useEffect } from 'react';
import { useOptionalCursor } from './CursorContext';

interface CursorScrollFollowerProps {
  scrollToBranch: (branchId: number) => void;
  /** Called whenever cursor.branchId changes (including on mount). Skipped for placeholder id 0. */
  onBranchIdChange?: (branchId: number) => void;
}

/**
 * Bridges cursor.branchId changes into the class component that owns the canvas.
 * Must be rendered inside CursorProvider. Renders nothing — side-effect only.
 */
export function CursorScrollFollower({ scrollToBranch, onBranchIdChange }: CursorScrollFollowerProps) {
  const cursorCtx = useOptionalCursor();
  const branchId = cursorCtx?.cursor.branchId;

  useEffect(() => {
    if (branchId === undefined || branchId === 0) return;
    scrollToBranch(branchId);
    onBranchIdChange?.(branchId);
  }, [branchId, scrollToBranch, onBranchIdChange]);

  return null;
}
